import React from 'react';
import { Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ViewDocModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: (open: boolean) => void;
  title?: string;
  children: React.ReactNode;
}

const ViewDocModal: React.FC<ViewDocModalProps> = ({
  open,
  onClose,
  setOpen,
  title = 'View Document',
  children
}) => {
  return (
    <Modal className="modal viewDoc_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{title}</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <div className="modal-content">
            {children}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewDocModal; 